import type { StarfishIconRef } from '@/app/common/icons/starfish';
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PROMOTION_TYPES } from '@/domainLogic/index.ts';
import type { FeatureType } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';
import type { DealCard } from '../../utils/buildDealCards/dealCardTypes';
import type { ClickParams } from '../../Curiosity/Analytics/utils';

export enum CARD_TYPE {
  STANDARD = 'standard',
  OVERLAY = 'overlay',
  MODAL = 'modal',
}

type CounterTranslations = {
  d: string;
  h: string;
  m: string;
  s: string;
  days: string;
  hrs: string;
  mins: string;
  secs: string;
  day: string;
};

export type FlashSalesConfig = {
  isActive?: boolean;
  expiration?: string;
  labelUsp?: string;
  expirationLabel?: string;
  expiredLabel?: string;
  counterTranslations?: CounterTranslations;
} | null;

export type PromotionPriceArea = {
  icon?: StarfishIconRef | string;
  text?: string;
  className?: string;
  promotionType?: PROMOTION_TYPES;
  callback?: () => void;
  element?: React.ReactNode;
};

export type PromotionContentArea = {
  icon: string;
  text: string;
  promotionType?: PROMOTION_TYPES;
  featureType: FeatureType;
  className?: string;
  iconRight?: string;
  tooltip?: any;
  tooltipSize?: number;
  element?: React.ReactNode;
};

export type PromotionConfig = PromotionPriceArea | PromotionContentArea;

export type Dot = {
  type?: string;
  hotelId: number;
  lng: number;
  lat: number;
  price: string;
  myPrice: boolean;
  flashSale: boolean;
};

export type HandleDealCardCtaCallBackProps = {
  e?:
    | React.MouseEvent<HTMLAnchorElement, MouseEvent>
    | React.MouseEvent<HTMLDivElement, MouseEvent>
    | React.MouseEvent<HTMLButtonElement, MouseEvent>;
  payload: ClickParams;
  selectedAlternativeDatesIndex?: number;
};
export type HandleDealCardCtaCallBack = ({
  e,
  payload,
  selectedAlternativeDatesIndex,
}: HandleDealCardCtaCallBackProps) => void;

export type DealCardCtaCallBackParams = {
  e?:
    | React.MouseEvent<HTMLAnchorElement, MouseEvent>
    | React.MouseEvent<HTMLDivElement, MouseEvent>
    | React.MouseEvent<HTMLButtonElement, MouseEvent>;
  dealCard?: DealCard;
  payload?: ClickParams;
  selectedAlternativeDatesIndex?: number;
};

export type DealCardCtaCallBack = (params: DealCardCtaCallBackParams) => void;

export type CardProps = {
  dealCard?: DealCard;
  type?: CARD_TYPE;
  isOverlay: boolean;
  setCardOverHotelId?: React.Dispatch<React.SetStateAction<number | undefined>>;
  dealCardCtaCallBack: DealCardCtaCallBack;
  className?: string;
  onClose?: () => void;
};
